import * as React from "react";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import { useEffect, useState } from "react";
import Parse from "../../API/ParseServer";
import styles from "./BlogTab.module.css";
import long from "../../Assets/memorabilia/Long-Sleeve-examples.webp";
import teared from "../../Assets/memorabilia/Teared-sholdier.webp";
import aliDaei from "../../Assets/memorabilia/Ali-Daei1.webp";
import { motion } from "motion/react";

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",

    // padding: "12px",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "black",
    Padding: "3px",
  },
  borderBottom: "2px solid #dad9da",
  boxSizing: "inherit",
  // "& .MuiTabs-indicator": {
  //   backgroundColor: "#1890ff",
  // },
  "& .MuiTabs-scroller": {
    overflow: "scroll !important",
    "&::-webkit-scrollbar": {
      display: "none !important",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(20),
  marginRight: theme.spacing(1),
  color: "gray",
  "&.Mui-selected": {
    color: "black",
    boxShadow: "0 4px #0a0a0a",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "black",
    boxShadow: "0 4px #0a0a0a",
  },
}));
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box py={2}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// export default function CustomizedTabs();
const CaseStudyTab: React.FC<{
  // description: string;
  // year: number;
  // subjects: string[];
  // styles: string[];
  // mediums: string[];
}> = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [selectedTopics, setSelectedTopics] = useState<any>([]);
  const [tabs, setTabs] = useState<any>([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTabs = async () => {
      const query = new Parse.Query("MemorabiliaTab");
      try {
        const results = await query.find();
        if (results.length > 0) {
          console.log(results);
          setTabs(results);
        } else {
          throw new Error("Tab not found.");
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTabs();
  }, []);
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 },
    },
  };
  return (
    <Box sx={{ width: "100%" }}>
      {tabs && (
        <React.Fragment>
          <Box>
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="styled tabs example"
              sx={{ overflow: "scroll" }}
            >
              {tabs.map((tab: any, index: any) => (
                <StyledTab label={tab.get("title")} {...a11yProps(index)} />
              ))}
            </StyledTabs>
          </Box>
          {tabs.map((tab: any, index: any) => (
            <CustomTabPanel value={value} index={index}>
              <Box sx={{ width: "100%", px: { md: 4, xs: 1 }, py: 3 }}>
                {tab.get("text1").map((item: any) => (
                  <React.Fragment>
                    <motion.div
                      variants={textVariants}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.5 }}
                    >
                      <Typography>{item}</Typography>
                    </motion.div>
                    <br />
                  </React.Fragment>
                ))}

                <img
                  src={tab.get("image").url()}
                  alt={tab.get("title")}
                  style={{ width: "100%" }}
                />
                {tab.get("text2").map((item: any) => (
                  <React.Fragment>
                    {" "}
                    <motion.div
                      variants={textVariants}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.5 }}
                    >
                      <Typography>{item}</Typography>
                    </motion.div>
                    <br />
                  </React.Fragment>
                ))}
                <br />
              </Box>
            </CustomTabPanel>
          ))}
        </React.Fragment>
      )}
    </Box>
  );
};
export default CaseStudyTab;
